import { PageHeader } from "../Components/Common";
import { Button, Empty, Tag } from "../Components/Base";
import { LoadingContext, MainContext } from "../Context";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { TransactionGetCoachs } from "../Services/Transactions";
import { CoachsListType } from "../Structures";

const Coachs = () => {
  const navigate = useNavigate();
  const { setting } = useContext(MainContext);
  const { loading, setLoading } = useContext(LoadingContext);

  // ======================================================================

  const [coachsList, setCoachsList] = useState<CoachsListType[]>([]);

  // ======================================================================

  const handleClickVisitProfile = (coachId: number) => {
    navigate(`/coachs/${coachId}`);
  };

  // ======================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetCoachs()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setCoachsList(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ======================================================================

  return (
    <Fragment>
      <PageHeader src={setting.coach_banner} title="مربیان" />
      <Empty
        data={coachsList}
        isLoading={loading}
        description="درحال حاضر استادی وجود ندارد"
      >
        <section className="position-relative pt-0">
          <div className="container" data-sticky-container>
            <div className="row">
              <div className="col-12">
                <div className="row gy-4">
                  {coachsList.map((coach: CoachsListType) => (
                    <div key={coach.id} className="col-12 col-md-6 col-lg-4">
                      <div className="card p-3 border rounded-3 h-100">
                        <div className="position-relative d-flex justify-content-center align-items-center">
                          <img
                            style={{ height: 200 }}
                            className="card-img w-auto"
                            src={coach.user.profile}
                            alt="Card image"
                          />
                        </div>
                        <div className="card-body px-0 pt-3 d-flex flex-column">
                          <h5 className="card-title fw-bold text-center text-black">
                            <a className="btn-link text-reset">
                              {coach.user.fullname} - {coach.gymName}
                            </a>
                          </h5>
                          {coach.position ? (
                            <p
                              className="text-center fw-bold mb-2 text-black"
                              style={{ fontSize: 14 }}
                            >
                              {coach.position}
                            </p>
                          ) : (
                            "-"
                          )}
                          <p className="card-text text-justify flex-grow-1 coach-desc">
                            {coach.gymAddress}
                          </p>
                          <Button
                            btnClass="w-100 btn-primary-soft m-0"
                            onClick={() => handleClickVisitProfile(coach.id)}
                            text="مشاهده پروفایل"
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* <Pagination /> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </Empty>
    </Fragment>
  );
};

export default Coachs;
